export default __webpack_public_path__ + "static/media/info.f2a44250.png";